import React from 'react';
import { TimeInterval } from '@cotera/api';
import { ServiceSummaryCards } from '../components/service-summary-cards';
import { StatusSummaryTable } from '../status-summary-table';
import { ActiveInvocationsGrouped } from '../components/active-invocations-grouped';

interface OverviewTabProps {
  timeInterval: TimeInterval;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ timeInterval }) => {
  return (
    <div className="space-y-6">
      <React.Suspense
        fallback={
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="h-24 rounded-lg border bg-card animate-pulse"
              />
            ))}
          </div>
        }
      >
        <ServiceSummaryCards timeInterval={timeInterval} />
      </React.Suspense>

      <React.Suspense
        fallback={
          <div className="h-48 rounded-lg border bg-card animate-pulse" />
        }
      >
        <StatusSummaryTable timeInterval={timeInterval} />
      </React.Suspense>

      <React.Suspense
        fallback={
          <div className="h-64 rounded-lg border bg-card animate-pulse" />
        }
      >
        <ActiveInvocationsGrouped timeInterval={timeInterval} />
      </React.Suspense>
    </div>
  );
};
